"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var slate_1 = require("slate");
var WidgetManager_1 = require("../../WidgetManager");
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var slate_react_1 = require("slate-react");
var LinkWidgetToolbar_1 = require("./LinkWidgetToolbar");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var MenuState;
(function (MenuState) {
    MenuState["Hidden"] = "link-widget--hidden";
    MenuState["Display"] = "link-widget--display";
    MenuState["Focused"] = "link-widget--focused";
})(MenuState || (MenuState = {}));
var LinkWidget = (function (_super) {
    __extends(LinkWidget, _super);
    function LinkWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toolbarRef = (0, react_1.createRef)();
        _this.hoverToolbar = false;
        _this.hoverText = false;
        _this.hasInvalidUrl = false;
        _this.removeLink = function () {
            var updateData = {
                action: "remove",
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("link", updateData));
        };
        _this.saveOnBlur = function (href) {
            if (href == "") {
                _this.removeLink();
            }
            else {
                _this.saveLinkData(href);
            }
        };
        _this.saveLinkData = function (href) {
            var correctedHref = (0, CorrectLink_1.default)(href);
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                href: correctedHref,
            };
            _this.href = correctedHref;
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("link", updateData));
        };
        _this.onFocus = function () {
            _this.linkDisplayState = MenuState.Focused;
        };
        _this.setUrlError = function (hasError) {
            _this.hasInvalidUrl = hasError;
        };
        _this.onBlur = function (event, href) {
            var isHrefValid = true;
            if (href) {
                isHrefValid = (0, URL_1.isURL)((0, CorrectLink_1.default)(href), true);
                _this.setUrlError(!isHrefValid);
            }
            if (isHrefValid) {
                _this.saveOnBlur(href);
            }
            if (!_this.hoverToolbar) {
                if (isHrefValid) {
                    _this.linkDisplayState = MenuState.Hidden;
                }
            }
            else {
                _this.linkDisplayState = MenuState.Display;
            }
        };
        _this.onMouseOverToolbar = function () {
            _this.hoverToolbar = true;
        };
        _this.onMouseOutToolbar = function () {
            _this.hoverToolbar = false;
            if (_this.linkDisplayState != MenuState.Focused && !_this.hoverText) {
                _this.linkDisplayState = MenuState.Hidden;
            }
        };
        _this.onMouseOverText = function () {
            _this.hoverText = true;
            if (_this.linkDisplayState != MenuState.Focused) {
                _this.setUrlError(false);
                _this.linkDisplayState = MenuState.Display;
                _this.showContextualStyle = false;
            }
        };
        _this.onMouseOutText = function (event) {
            _this.hoverText = false;
            if (event.relatedTarget == _this.toolbarRef.current) {
                return;
            }
            if (_this.linkDisplayState != MenuState.Focused && !_this.hoverToolbar) {
                _this.linkDisplayState = MenuState.Hidden;
            }
        };
        _this.collapsedSelection = function () {
            var editor = _this.props.widgetManager.editor;
            if (!editor.selection) {
                return false;
            }
            var selectedText = slate_1.Editor.string(editor, editor.selection);
            var hasNoSelection = slate_1.Range.isCollapsed(editor.selection) || !slate_react_1.ReactEditor.isFocused(editor) || selectedText.length == 0;
            return hasNoSelection;
        };
        _this.openLinkInNewTab = function (event) {
            event.preventDefault();
            if (_this.href == "") {
                return;
            }
            window.open((0, CorrectLink_1.default)(_this.href), "_blank");
            return true;
        };
        _this.toggleShowStyle = function (event) {
            event.stopPropagation();
            _this.showContextualStyle = !_this.showContextualStyle;
        };
        _this.renderLinkToolbar = function () {
            var _a = _this.props, focus = _a.focus, widgetManager = _a.widgetManager, toolbarHost = _a.toolbarHost;
            var doNotRenderLinkToolbar = !(_this.readyToRenderLinkToolbar &&
                widgetManager.canEdit &&
                _this.collapsedSelection &&
                toolbarHost.current &&
                (_this.linkDisplayState !== MenuState.Hidden || focus));
            if (doNotRenderLinkToolbar) {
                return;
            }
            var _b = _this.props, href = _b.href, blockStore = _b.blockStore, brandStore = _b.brandStore, attributes = _b.attributes, contextualStylesAllowed = _b.contextualStylesAllowed;
            var shouldShowStyleButton = _this.usingTCDC && contextualStylesAllowed;
            return (react_1.default.createElement(LinkWidgetToolbar_1.LinkWidgetToolbar, { focus: focus, href: href, blockStore: blockStore, brandStore: brandStore, linkDisplayState: _this.linkDisplayState, onMouseOutToolbar: _this.onMouseOutToolbar, onMouseOverToolbar: _this.onMouseOverToolbar, showContextualStyle: _this.showContextualStyle, showStyleButton: shouldShowStyleButton, toggleShowStyle: _this.toggleShowStyle, toolbarHost: toolbarHost, usingTCDC: _this.usingTCDC, onBlur: _this.onBlur, onFocus: _this.onFocus, removeLink: _this.removeLink, toolbarRef: _this.toolbarRef, widgetRef: attributes.ref, hasError: _this.hasInvalidUrl }));
        };
        _this.linkDisplayState = MenuState.Hidden;
        _this.href = _this.props.href;
        _this.usingTCDC = (0, FeatureFlag_1.isUsingTCDC)(props.usingFeature);
        _this.showContextualStyle = false;
        return _this;
    }
    LinkWidget.prototype.componentDidMount = function () {
        this.readyToRenderLinkToolbar = true;
    };
    LinkWidget.prototype.render = function () {
        var linkStyle = this.props.blockStore.blockStyleStore.getElementStyle("link");
        var style = {};
        if (this.props.computeLinkColor) {
            var computedColor = this.props.computeLinkColor(this.props.colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(linkStyle.color)).value);
            style = { color: computedColor, borderBottomColor: computedColor };
        }
        return (react_1.default.createElement("span", __assign({ className: "link-widget" }, this.props.attributes),
            react_1.default.createElement("a", { onClick: this.openLinkInNewTab, href: (0, CorrectLink_1.default)(this.href), onMouseEnter: this.onMouseOverText, onMouseLeave: this.onMouseOutText, target: "_blank", style: style }, this.props.children),
            this.renderLinkToolbar()));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LinkWidget.prototype, "linkDisplayState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LinkWidget.prototype, "href", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], LinkWidget.prototype, "showContextualStyle", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "hasInvalidUrl", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], LinkWidget.prototype, "readyToRenderLinkToolbar", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "saveOnBlur", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "saveLinkData", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onFocus", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "setUrlError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onBlur", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onMouseOverToolbar", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onMouseOutToolbar", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onMouseOverText", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "onMouseOutText", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "openLinkInNewTab", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidget.prototype, "toggleShowStyle", void 0);
    LinkWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], LinkWidget);
    return LinkWidget;
}(react_1.default.Component));
exports.default = LinkWidget;
